var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconWordcloud = function SvgIconWordcloud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: 32,
      height: 32,
      verticalAlign: "middle",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M465.455 232.727A209.455 209.455 0 0 0 256 442.182c0 24.739 4.515 48.337 12.381 70.353a139.567 139.567 0 0 0 10.892 278.738h418.909a186.182 186.182 0 0 0 0-372.364c-8.285 0-16.384 0.722-24.367 1.769a209.455 209.455 0 0 0-208.36-187.95m0 46.545a162.304 162.304 0 0 1 162.048 146.13l4.864 47.662 47.5-6.214c7.19-0.954 13.009-1.396 18.315-1.396 77.01 0 139.636 62.626 139.636 139.636s-62.627 139.636-139.636 139.636h-418.91c-51.339 0-93.09-41.751-93.09-93.09a93.393 93.393 0 0 1 85.783-92.673l60.742-4.724-20.503-57.344a162.583 162.583 0 0 1-9.659-54.714c0-89.833 73.077-162.91 162.91-162.91"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWordcloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-wordcloud.ff97e2ff.svg";
export { ForwardRef as ReactComponent };